

















import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import SortSelection from '@/views/search/filter/SortSelection.vue';


@Component({
  components: {SortSelection},
})
export default class SearchFilterOption extends Vue {
  @Model('change')
  public selected!: boolean;

  @Prop({required: false, default: 0})
  public resultCount!: number;

  public onToggle(newValue: boolean) {
    this.$emit('change', newValue);
  }
}
